import { esc } from "./escape.js";
import { DEFAULT_ITEM_IMAGE } from "./defaultImage.js";

// Generic stand-in when an item has neither a photo nor a chosen icon emoji,
// used ONLY while forcing emoji-tile rendering (New Order's Emoji display
// mode, the Catalogue corner badge) - reuses the same package glyph as the
// New Order empty-state icon. Everywhere else, a blank item falls back to
// the existing neutral `DEFAULT_ITEM_IMAGE` placeholder instead, so "Photo
// mode" never shows an emoji tile just because an item has neither.
export const DEFAULT_EMOJI = "📦";

// Resolves a menu item's catalogue image. The two modes are fully separate,
// not a fallback chain into each other - "Photo" never shows an emoji just
// because one happens to be set, and "Emoji" never shows a photo:
//   - normal (photo) mode: the uploaded photo, or the neutral placeholder.
//   - { emojiOnly: true }: the chosen emoji as an inline SVG data-URI tile,
//     or the default emoji tile - used by New Order's Emoji display mode
//     (see newOrderView.js) and the Catalogue corner badge.
export const itemImageSrc = function (item, { emojiOnly = false } = {}) {
  if (emojiOnly) return emojiTileDataUri(item?.iconEmoji || DEFAULT_EMOJI);
  return item?.imageURL || DEFAULT_ITEM_IMAGE;
};

const emojiTileDataUri = function (emoji) {
  // Untrusted (user-typed/pasted) text going into markup - esc() per
  // CLAUDE.md "Output Escaping (XSS)", even though <img src="data:..."> already
  // disables SVG script execution: defense in depth, and this SVG string is
  // itself the kind of stored value a future consumer (e.g. the admin panel)
  // could render differently.
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'>
  <rect width='120' height='120' rx='18' fill='#f0fdf4'/>
  <text x='60' y='66' font-size='58' text-anchor='middle' dominant-baseline='central'>${esc(emoji)}</text>
</svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
